import React, { useState } from 'react'

import Button from '../../../../Button/Button';
import svgToggleLeftBtn from '../../../../../assets/img/icon/toggle-button-left.svg';
import svgToggleRightBtn from '../../../../../assets/img/icon/toggle-button-right.svg';
import rightArrowSvg from '../../../../../assets/img/icon/right-arrow.svg';
import convBubbleSvg from '../../../../../assets/img/icon/conversation-bubble.svg';
import checkSvg from '../../../../../assets/img/icon/check-02.svg';


import { pricingItems } from './constants';

import './PricingItems.scss';

import { signupLink, contactFormLink } from '../../../../../Constants' 



const PricingItems = ({ currentLangKey }) => {
  const [toggle, setToggle] = useState(false)

  const handleToggleClick = () => {
    setToggle(!toggle)
  }

  const pricingItemsData = pricingItems[currentLangKey]
  const pricingItemsArr = pricingItems[currentLangKey].details

  return (
    <div className={`pricing-section ${currentLangKey}`}>
      <div className="pricing-section__button-section">
        {/* popu text for on the left */}
        {toggle && 
          <div className={`popup ${currentLangKey}`}>
            <div className={`text meta-pop-up-text ${currentLangKey}`}>{pricingItemsData.savingPopUp}</div>
            <img className="down-arrow" src={rightArrowSvg} alt="arrow"/>
          </div> 
        }
        
        <Button 
          className="pricing-section__button-section__button-wrapper" 
          type="toggleUsingState" 
          labelOrginal={pricingItemsData.buttonLabel1}
          labelToggled={pricingItemsData.buttonLabel2}
          imgOrginal={svgToggleLeftBtn} 
          imgToggled={svgToggleRightBtn} 
          callback={handleToggleClick} />
      </div>
      <div className="pricing-section__pricingItems">
        {pricingItemsArr.map((groups, index) => {
            return (
              <div className="pricing-section__pricingItems__category pricing-plan-category" key={groups[0].category + index}>
                <div className="category-header">{groups[0].category === "individual" ? pricingItemsData.header1 : pricingItemsData.header2}</div>
                {groups.map((product, index) =>
                  <div className="pricing-section__pricingItems__category__pricing-plan" id={`${product.id}`} key={product.title + index}>
                    <div className="plan-title">{product.title}</div>
                    <div className="price-wrapper">
                      <div className={`price-header ${product.priceCustom && "custom"}`}>
                        {product.priceFree && product.priceFree}
                        {!product.priceFree && !toggle && product.priceAnnual}
                        {!product.priceFree && toggle && product.priceMonthly}
                        {product.priceCustom && <img className="icon" src={convBubbleSvg} alt=""/>}
                        {product.priceCustom && <a className={currentLangKey} href={contactFormLink}>{product.priceCustom}</a>}
                      </div>
                      {product.unitOne &&
                        <div className={`pricing-unit ${currentLangKey}`}>
                          {product.unitOne && <div className="unit-one">{product.unitOne}</div>}
                          {product.unitTwo && <div className="unit-two">{product.unitTwo}</div>}
                        </div>
                      }
                    </div>
                    <Button text={product.buttonTxt} href={signupLink} />
                    <div className="summary">{product.summary}</div>
                    <div className="desc-heading">{product.heading}</div>
                    <>{product.items.map(item => <div className="desc" key={item}><img src={checkSvg} alt=""/>{item}</div>)}</>
                  </div> 
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default PricingItems
